import Image from "next/image";
import { Trans } from "next-i18next";

import { useCheckIsMobile } from "@sellernote/shared/src/utils/hook";
import useOnceActivatedIntersectionObserver from "@sellernote/features/src/common/hooks/useOnceActivatedIntersectionObserver";
import CommonStyled from "@sellernote/shipda-kr/src/components/landing/index.styles";
import Chip from "@sellernote/ui/src/sds-v2/components/Chip";

import Styled from "./index.styles";

export default function LandingSectionValue() {
  const { isMobile } = useCheckIsMobile();

  const { target, isActivatedTarget } = useOnceActivatedIntersectionObserver({
    threshold: 0.3,
  });

  return (
    <Styled.containerWrapper ref={target}>
      <Styled.container>
        <Styled.contentsContainer>
          <Chip
            chipType="outline"
            label={<Trans i18nKey="page-company:밸류섹션_뱃지" />}
            className={`fade-up-animation ${isActivatedTarget ? "active" : ""}`}
          />

          <CommonStyled.sectionTitle
            className={`fade-up-animation ${isActivatedTarget ? "active" : ""}`}
          >
            <Trans i18nKey="page-company:밸류섹션_타이틀" />
          </CommonStyled.sectionTitle>

          <CommonStyled.sectionDesc
            className={`fade-up-animation ${isActivatedTarget ? "active" : ""}`}
          >
            <Trans i18nKey="page-company:밸류섹션_설명" />
          </CommonStyled.sectionDesc>
        </Styled.contentsContainer>

        <Styled.valueList>
          {[1, 2, 3].map((order) => (
            <Styled.valueItem
              key={`value-item-${order}`}
              className={`fade-up-animation ${
                isActivatedTarget ? "active" : ""
              }`}
              delay={`0.${order + 5}s`}
            >
              <Styled.imageWrapper
                className={`${
                  isMobile
                    ? `fade-up-animation`
                    : `fade-in-and-spring-animation`
                } ${isActivatedTarget ? "active" : ""}`}
              >
                <Image
                  src={
                    isMobile
                      ? `/assets/images/company/value-section-${order}-m.webp`
                      : `/assets/images/company/value-section-${order}.webp`
                  }
                  alt={`section-image`}
                  width={isMobile ? 328 : 360}
                  height={160}
                  placeholder="blur"
                  layout={isMobile ? "fill" : "fixed"}
                  blurDataURL="/assets/images/landing/section-image-blur-data.png"
                />
              </Styled.imageWrapper>

              <h4>
                <Trans
                  i18nKey={`page-company:밸류섹션_아이템${order}_타이틀`}
                />
              </h4>

              <p>
                <Trans i18nKey={`page-company:밸류섹션_아이템${order}_설명`} />
              </p>
            </Styled.valueItem>
          ))}
        </Styled.valueList>
      </Styled.container>
    </Styled.containerWrapper>
  );
}
